import { axiosInstance } from "../axios";

export const comboApi = {
  getAll: async (params) => {
    return await axiosInstance.get("/combo", { params });
  },
  getPaginate: (params) => axiosInstance.get(`/combo/paginate`, { params }),
  getComboById: async (id) => {
    return await axiosInstance.get(`/combo/${id}`);
  },
  create: async (body) => {
    return await axiosInstance.post("/combo", body);
  },
  update: async (id, body) => {
    return await axiosInstance.put(`/combo/${id}`, body);
  },
  remove: async (id) => {
    return await axiosInstance.delete(`/combo/${id}`);
  },
  stop: async (id) => {
    return await axiosInstance.put(`/combo/${id}/stop`);
  },
  getAllProposals: async () => {
    return await axiosInstance.get(`/combo-proposals`);
  },
  getPaginateProposals: (params) =>
    axiosInstance.get(`/combo-proposals/paginate`, { params }),
  createProposal: async (body) => {
    return await axiosInstance.post("/combo-proposals", body);
  },
  getProposalById: async (id) => {
    return await axiosInstance.get(`/combo-proposals/${id}`);
  },
  updateProposal: async (id, body) => {
    return await axiosInstance.put(`/combo-proposals/${id}`, body);
  },
  removeProposal: async (id) => {
    return await axiosInstance.delete(`/combo-proposals/${id}`);
  },
  approveProposal: async (id) => {
    return await axiosInstance.put(`/combo-proposals/${id}/approval`);
  },
};
